// Общ избор на снимки от галерията — ПО НЯКОЛКО наведнъж.
// Качва избраните паралелно и връща URL-ите; грешките се събират в едно
// съобщение, а успешните пак се добавят (частичен успех не блокира).

import * as ImagePicker from 'expo-image-picker';
import { uploadFile } from './api';
import { showError } from './toast';
import { t } from './i18n';

// Снимка от камерата е 4000×3000 и 2–4 MB — quality на пикера компресира
// JPEG-а, но НЕ преоразмерява, затова качването е бавно. За екран и
// документи 1600 px по дългата страна стигат (~200–400 KB, пъти по-бързо).
const MAX_SIDE = 1600;

export async function compressAndUploadPhoto(asset: {
  uri: string;
  width?: number;
  height?: number;
}): Promise<string> {
  const { uri, width = 0, height = 0 } = asset;
  const longest = Math.max(width, height);
  // По-малките не се пипаме — resize би ги УВЕЛИЧИЛ.
  if (!longest || longest <= MAX_SIDE) return uploadFile(uri);

  try {
    // Модулът се зарежда ЧАК ТУК, не горе с import: на билд без вградения
    // нативен код зареждането гърми, а гръм при стартиране кара
    // expo-updates да върне ЦЯЛОТО обновление назад. Тук грешката се
    // хваща и снимката просто се качва некомпресирана.
    const { ImageManipulator, SaveFormat } = await import('expo-image-manipulator');
    const context = ImageManipulator.manipulate(uri);
    context.resize(width >= height ? { width: MAX_SIDE } : { height: MAX_SIDE });
    const rendered = await context.renderAsync();
    const saved = await rendered.saveAsync({ format: SaveFormat.JPEG, compress: 0.7 });
    return uploadFile(saved.uri);
  } catch {
    // Провалена компресия не бива да спре качването — просто е по-бавно.
    return uploadFile(uri);
  }
}

export async function pickAndUploadPhotos(limit = 10): Promise<string[]> {
  const result = await ImagePicker.launchImageLibraryAsync({
    mediaTypes: ['images'],
    quality: 0.7,
    allowsMultipleSelection: true,
    selectionLimit: limit,
    orderedSelection: true,
  });
  if (result.canceled || result.assets.length === 0) return [];

  const settled = await Promise.allSettled(result.assets.map((a) => compressAndUploadPhoto(a)));
  const urls = settled.filter((s): s is PromiseFulfilledResult<string> => s.status === 'fulfilled').map((s) => s.value);
  const failed = settled.length - urls.length;
  if (failed > 0) {
    showError(
      failed === settled.length
        ? t('Качването се провали.')
        : t('{failed} от {total} снимки не се качиха.', { failed, total: settled.length })
    );
  }
  return urls;
}
